import { render, staticRenderFns } from "./OrganisationActions.vue?vue&type=template&id=4e42e350&scoped=true"
import script from "./OrganisationActions.vue?vue&type=script&lang=js"
export * from "./OrganisationActions.vue?vue&type=script&lang=js"
import style0 from "./OrganisationActions.vue?vue&type=style&index=0&id=4e42e350&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e42e350",
  null
  
)

export default component.exports